module.exports = __webpack_public_path__ + "img/icon-google.775ae2cf.svg";